import { Box, InputBase, styled, Toolbar } from '@mui/material';

import { Link } from '../../core/link';

export const Search = styled('div')(({ theme }) => ({
  '&&& .MuiInputBase-root': {
    height: '40px',
    paddingTop: '4px',
  },
  backgroundColor: theme.palette.grey[200],
  borderRadius: '20px',
  height: theme.spacing(5),
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(2),
  position: 'relative',
  [theme.breakpoints.up('md')]: {
    width: '426px',
  },
  width: '100%',
}));

export const SearchIconWrapper = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  padding: theme.spacing(0, 2),
  pointerEvents: 'none',
  position: 'absolute',
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    [theme.breakpoints.up('md')]: {
      width: '426px',
    },
    transition: theme.transitions.create('width'),
    width: '100%',
  },
  color: 'inherit',
}));

export const TopBarWrapper = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  backdropFilter: 'blur(8px)',
  background: theme.palette.background.paper + '80',
  borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  display: 'flex',
  flexDirection: 'column',
  position: 'sticky',
  top: '0',
  width: '100%',
  zIndex: '100',
}));

export const StyledToolbar = styled(Toolbar)({
  maxWidth: '1280px',
  paddingLeft: '16px',
  paddingRight: '16px',
  width: '100%',
});

export const HomeLink = styled(Link)(({ theme }) => ({
  '& svg': {
    marginTop: theme.spacing(1),
  },
  marginLeft: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    '& svg': {
      width: 'unset',
    },
  },
}));
